import { render, staticRenderFns } from "./nav-drop-zone.vue?vue&type=template&id=97e4f718&scoped=true&"
import script from "./nav-drop-zone.vue?vue&type=script&lang=ts&"
export * from "./nav-drop-zone.vue?vue&type=script&lang=ts&"
import style0 from "./nav-drop-zone.vue?vue&type=style&index=0&id=97e4f718&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e4f718",
  null
  
)

export default component.exports